import { render, staticRenderFns } from "./HazardousSelector.vue?vue&type=template&id=3ef57d9a&scoped=true"
import script from "./HazardousSelector.vue?vue&type=script&lang=js"
export * from "./HazardousSelector.vue?vue&type=script&lang=js"
import style0 from "./HazardousSelector.vue?vue&type=style&index=0&id=3ef57d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef57d9a",
  null
  
)

export default component.exports